import axios from "axios";

const API_KEY = "65960fc8b8af5da96a72b47a233a80d5";

export interface WeatherItem {
    weather: {
        main: string;
        description: string;
        icon: string;
    }[];
    main: {
        temp: number;
    }
    rain?: {
        "1h"?: number;
    };
    wind: {
        speed: number;
    }
    sys: {
        sunrise: number;
        sunset: number;
    }
}

export interface ListWeatherItem {
    dt: number;
    dt_txt: string;

    weather: {
        main: string;
        description: string;
        icon: string;
    }[];

    main: {
        temp: number;
    };
}

export interface ListWeatherResponse {
    list: ListWeatherItem[];
}

export const fetchWeather = async (): Promise<WeatherItem> => {
    const { data } = await axios.get<WeatherItem>(
        `https://api.openweathermap.org/data/2.5/weather?q=Ho Chi Minh&units=metric&lang=vi&appid=${API_KEY}`
    );

    return data;
};

export const fetchListWeather = async (): Promise<ListWeatherResponse> => {
    const { data } = await axios.get<ListWeatherResponse>(
        `https://api.openweathermap.org/data/2.5/forecast?q=Ho%20Chi%20Minh&units=metric&lang=vi&appid=${API_KEY}`
    );

    return data;
};